import { BaseClass } from '../..';
import { RadioModel, RadioOptionsModel, InputValue, InputTypes } from '..';
import { dropProps } from '../..';

export class RadioOtionsClass extends BaseClass<RadioOptionsModel> implements RadioOptionsModel {
  get disabled(): boolean {
    return this.props.disabled;
  }
  get label(): string {
    return this.props.label;
  }
  get selected(): boolean {
    return this.props.selected;
  }
  get value(): string | number | string[] | undefined {
    return this.props.value;
  }
}

export class RadioClass extends BaseClass<RadioModel> implements RadioModel {
  get defaultValue(): InputValue | undefined {
    return this.props.defaultValue;
  }
  get disabled(): boolean {
    return this.props.disabled;
  }
  get error(): boolean {
    return this.props.error;
  }
  get errorMessage(): string | undefined {
    return this.props.errorMessage;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  get name(): string {
    return this.props.name;
  }
  get options(): RadioOptionsModel[] {
    return this.props.options.map(options => dropProps(options, new RadioOtionsClass(options)));
  }
  get placeholder(): string | undefined {
    return this.props.placeholder;
  }
  get required(): boolean {
    return this.props.required;
  }
  get type(): InputTypes {
    return this.props.type;
  }
  get validation(): string | undefined {
    return this.props.validation;
  }
  get value(): InputValue {
    return this.props.value;
  }
}